"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Topbar = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _styles = require("@material-ui/core/styles");

var _withWidth = require("@material-ui/core/withWidth");

var _Help = _interopRequireDefault(require("@material-ui/icons/Help"));

var _Menu = _interopRequireDefault(require("@material-ui/icons/Menu"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _AppBar = _interopRequireDefault(require("../../AppBar"));

var _Avatar = _interopRequireDefault(require("../../Avatar"));

var _Button = _interopRequireDefault(require("../../Button"));

var _Menu2 = _interopRequireDefault(require("../../Menu"));

var _Toolbar = _interopRequireDefault(require("../../Toolbar"));

var _Typography = _interopRequireDefault(require("../../Typography"));

var _OrganizationHelper = require("../../Utilities/OrganizationHelper");

var _ThemeHelper = require("../../Utilities/ThemeHelper");

var _ProductLogo = _interopRequireDefault(require("../Sidebar/ProductLogo"));

var _styles2 = require("./styles");

var _Fade = _interopRequireDefault(require("@material-ui/core/Fade"));

var _core = require("@material-ui/core");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var Topbar = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Topbar, _Component);

  var _super = _createSuper(Topbar);

  function Topbar(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Topbar);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderAccountMenuOptions", function () {
      var accountMenuOptions = _this.props.accountMenuOptions;
      var options = [];

      if (accountMenuOptions.menuItems) {
        options.push.apply(options, (0, _toConsumableArray2.default)(accountMenuOptions.menuItems));
      }

      if (accountMenuOptions.includeDefault) {
        options.push({
          display: "Reset Password",
          action: function action() {
            var _accountMenuOptions$r;

            var url = (_accountMenuOptions$r = accountMenuOptions.resetPasswordUrl) !== null && _accountMenuOptions$r !== void 0 ? _accountMenuOptions$r : "".concat(accountMenuOptions.platformBaseUrl, "/ResetPassword");
            window.open(url, "_blank");
          }
        });
        options.push({
          display: "Settings",
          action: function action() {
            var _accountMenuOptions$s;

            var url = (_accountMenuOptions$s = accountMenuOptions.settingsUrl) !== null && _accountMenuOptions$s !== void 0 ? _accountMenuOptions$s : "".concat(accountMenuOptions.platformBaseUrl, "/Account/Settings");
            window.open(url, "_blank");
          }
        });
        options.push({
          display: "Sign Out",
          action: function () {
            var _action = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
              return _regenerator.default.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.t0 = accountMenuOptions.signoutOfProduct;

                      if (!_context.t0) {
                        _context.next = 4;
                        break;
                      }

                      _context.next = 4;
                      return accountMenuOptions.signoutOfProduct();

                    case 4:
                      window.open("".concat(accountMenuOptions.signoutUrl), "_self");

                    case 5:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee);
            }));

            function action() {
              return _action.apply(this, arguments);
            }

            return action;
          }()
        });
      }

      return options;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderHelpMenuOptions", function () {
      var helpMenuOptions = _this.props.helpMenuOptions;
      var options = [];

      if (helpMenuOptions.menuItems) {
        options.push.apply(options, (0, _toConsumableArray2.default)(helpMenuOptions.menuItems));
      }

      return options;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getMobileTitle", function () {
      var _this$props = _this.props,
          width = _this$props.width,
          currentOrg = _this$props.currentOrg,
          currentOrgSettings = _this$props.currentOrgSettings,
          type = _this$props.type,
          classes = _this$props.classes;
      var shouldDisplayName = !(0, _withWidth.isWidthUp)("md", width) && type === "external" && currentOrg;
      var title = (0, _OrganizationHelper.formatOrgName)(currentOrgSettings, currentOrg);
      return shouldDisplayName ? /*#__PURE__*/_react.default.createElement("div", {
        className: classes.left
      }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
        className: classes.displayName,
        variant: "h1"
      }, title)) : undefined;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "render", function () {
      var _this$props2 = _this.props,
          id = _this$props2.id,
          classes = _this$props2.classes,
          disableSidebar = _this$props2.disableSidebar,
          onMenuClicked = _this$props2.onMenuClicked,
          accountMenuOptions = _this$props2.accountMenuOptions,
          helpMenuOptions = _this$props2.helpMenuOptions,
          children = _this$props2.children,
          type = _this$props2.type,
          shouldCollapseMenu = _this$props2.shouldCollapseMenu,
          currentOrg = _this$props2.currentOrg,
          currentOrgSettings = _this$props2.currentOrgSettings,
          productLogo = _this$props2.productLogo,
          product = _this$props2.product,
          width = _this$props2.width,
          disableProductList = _this$props2.disableProductList,
          toggleProductList = _this$props2.toggleProductList,
          productListOpen = _this$props2.productListOpen,
          theme = _this$props2.theme;

      var renderedMobileTitle = _this.getMobileTitle();

      return /*#__PURE__*/_react.default.createElement(_AppBar.default, {
        color: "inherit",
        id: "".concat(id, "-appbar"),
        position: "fixed",
        className: (0, _classnames.default)("prmbl-topbar", classes.root, (0, _defineProperty2.default)({}, classes.internal, type === "internal" && !disableSidebar))
      }, /*#__PURE__*/_react.default.createElement(_core.Slide, {
        in: disableSidebar,
        direction: "right",
        unmountOnExit: true,
        appear: false
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: classes.logo
      }, /*#__PURE__*/_react.default.createElement(_ProductLogo.default, {
        onClick: !disableProductList ? toggleProductList : undefined,
        isOpen: !disableProductList ? productListOpen : undefined,
        id: id + "-productLogo",
        type: type,
        currentOrg: currentOrg,
        currentOrgSettings: currentOrgSettings,
        product: product,
        productLogo: productLogo,
        disableSidebar: disableSidebar
      }))), /*#__PURE__*/_react.default.createElement(_Toolbar.default, {
        color: "inherit",
        id: "preamble-page-toolbar",
        className: (0, _classnames.default)((0, _defineProperty2.default)({}, classes.toolbar, !disableSidebar))
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: classes.left
      }, /*#__PURE__*/_react.default.createElement(_Fade.default, {
        in: !disableSidebar && !(0, _withWidth.isWidthUp)("md", width) || !disableSidebar && shouldCollapseMenu,
        unmountOnExit: true,
        timeout: 4 * theme.transitions.duration.complex,
        exit: false,
        appear: false
      }, /*#__PURE__*/_react.default.createElement(_Button.default, {
        id: "".concat(id, "-menu"),
        type: "icon",
        title: "Menu",
        color: "inherit",
        onClick: onMenuClicked
      }, /*#__PURE__*/_react.default.createElement(_Menu.default, null)))), renderedMobileTitle, /*#__PURE__*/_react.default.createElement("div", {
        className: classes.middle
      }, children), (accountMenuOptions.show || helpMenuOptions.show) && /*#__PURE__*/_react.default.createElement("div", {
        className: classes.right
      }, accountMenuOptions.show && _this.state.user && /*#__PURE__*/_react.default.createElement(_Menu2.default, {
        id: "account-menu",
        title: "My Account",
        icon: /*#__PURE__*/_react.default.createElement(_Avatar.default, {
          id: "account-menu-user",
          name: "".concat(_this.state.user.firstName, " ").concat(_this.state.user.lastName),
          size: "small",
          email: "email" in _this.state.user && _this.state.user.email
        }),
        items: _this.renderAccountMenuOptions()
      }), helpMenuOptions.show && /*#__PURE__*/_react.default.createElement(_Menu2.default, {
        id: "help-menu",
        title: "Help",
        icon: /*#__PURE__*/_react.default.createElement(_Help.default, null),
        items: _this.renderHelpMenuOptions()
      }))));
    });
    _this.state = {
      user: null
    };
    return _this;
  }

  (0, _createClass2.default)(Topbar, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps.identityServerSdk !== this.props.identityServerSdk && this.props.identityServerSdk && this.props.identityServerSdk.GetUser) {
        var user = this.props.identityServerSdk.GetUser();
        this.setState({
          user: user
        });
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.identityServerSdk && this.props.identityServerSdk.GetUser) {
        var user = this.props.identityServerSdk.GetUser();
        this.setState({
          user: user
        });
      }
    }
  }]);
  return Topbar;
}(_react.Component);

exports.Topbar = Topbar;
(0, _defineProperty2.default)(Topbar, "propTypes", {
  /**
   * The html id
   */
  id: _propTypes.default.string.isRequired,

  /**
   * Options supplied to the account menu. Default options are Reset Password, Account Settings, and Sign Out.
   * Sign Out requires a signoutUrl which, depending on the product, requires parameters id_token_hint and post_logout_redirect_uri to be in the URL.
   */
  accountMenuOptions: _propTypes.default.shape({
    includeDefault: _propTypes.default.bool,
    menuItems: _propTypes.default.arrayOf(_propTypes.default.shape({
      display: _propTypes.default.string.isRequired,
      action: _propTypes.default.func.isRequired
    })),
    show: _propTypes.default.bool,
    platformBaseUrl: _propTypes.default.string.isRequired,
    signoutOfProduct: _propTypes.default.func,
    signoutUrl: _propTypes.default.string.isRequired,
    resetPasswordUrl: _propTypes.default.string,
    settingsUrl: _propTypes.default.string
  }),

  /**
   * @ignore
   *
   * Utilizing this to style up the page don't want to expose this in the style guide.
   * Auto-populated by material-ui withStyles()
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * Custom items to render in topbar
   */
  children: _propTypes.default.node,

  /**
   * Sidebar disabled
   */
  disableSidebar: _propTypes.default.bool,

  /**
   * Options supplied to the help menu
   */
  helpMenuOptions: _propTypes.default.shape({
    menuItems: _propTypes.default.arrayOf(_propTypes.default.shape({
      display: _propTypes.default.string.isRequired,
      action: _propTypes.default.func.isRequired
    })),
    show: _propTypes.default.bool
  }),

  /**
   * The html node to render as the product logo
   */
  productLogo: _propTypes.default.node,

  /**
   * Called when the hamburger menu button is clicked
   */
  onMenuClicked: _propTypes.default.func.isRequired,

  /**
   * The identitySeverSdk object. Requires accessToken, identityServerBaseUrl, and idToken.
   * Used to get the user's products and information.
   *
   * If no user is specified, a blank product list will be shown and a user avatar will be hidden.
   */
  identityServerSdk: _propTypes.default.object,

  /**
   * The type of page, which affects what logo and color is used
   */
  type: _propTypes.default.oneOf(["internal", "external"]),

  /**
   * The current organization's name
   */
  currentOrg: _propTypes.default.string,

  /**
   * The current organization's branding settings
   */
  currentOrgSettings: _propTypes.default.shape({
    name: _propTypes.default.string,
    id: _propTypes.default.string,
    settings: _propTypes.default.object
  }),

  /**
   * @ignore
   *
   * Auto-populated by Material-UI withWidth()
   */
  width: _propTypes.default.string.isRequired,

  /**
   * If `true` the menu will always collapse into a button, otherwise only on small screens
   */
  shouldCollapseMenu: _propTypes.default.bool,

  /**
   * Sets product colors and logo automatically. Can be overridden by primaryHex and productLogo
   */
  product: _propTypes.default.oneOf(Object.keys(_ThemeHelper.themes)),

  /**
   * @ignore
   *
   * Auto-populated by Material-UI withTheme()
   */
  theme: _propTypes.default.object,

  /**
   * If `true` the product list will not render
   */
  disableProductList: _propTypes.default.bool,

  /**
   * The function to toggle the product list open/close state
   */
  toggleProductList: _propTypes.default.func.isRequired,

  /**
   * The state of the product list
   */
  productListOpen: _propTypes.default.bool.isRequired
});
(0, _defineProperty2.default)(Topbar, "defaultProps", {
  accountMenuOptions: {},
  helpMenuOptions: {}
});
var EnhancedComponent = (0, _styles.withStyles)(_styles2.styles)((0, _core.withTheme)(Topbar));
var _default = EnhancedComponent;
exports.default = _default;